import Spinner from 'components/Spinner'
import React from 'react'
import { TableProps } from './Table.props'
import {
  TableContainer,
  TableContentContainer,
  TableFooterContainer,
  TableHeaderContainer,
  TableHeaderHead,
} from './Table.styled'
import TableCount from './TableCount'
import TablePagination from './TablePagination'

const Table = ({
  header,
  pagination,
  totalCount,
  children,
  loading,
  currentPage,
  onChangePage,
  styles,
}: TableProps) => (
  <>
    <TableContainer style={styles}>
      <TableHeaderContainer>
        {header.map((headerName, index) => (
          <TableHeaderHead key={`header-name_${index}`}>
            {headerName}
          </TableHeaderHead>
        ))}
      </TableHeaderContainer>

      <TableContentContainer>{!loading && children}</TableContentContainer>
    </TableContainer>
    {loading && (
      <div
        style={{
          display: 'flex',
          width: '100%',
          margin: '50px 0',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Spinner />
      </div>
    )}
    {pagination && totalCount && totalCount > 0 && !loading ? (
      <TableFooterContainer>
        <TableCount totalCount={totalCount} />
        {onChangePage && currentPage && (
          <TablePagination
            totalCount={totalCount}
            currentPage={currentPage}
            onChangePage={onChangePage}
          />
        )}
      </TableFooterContainer>
    ) : ''}
  </>
)

export default Table
